// extracted by mini-css-extract-plugin
export default {"head":"productsHead_head__4k6ik","right":"productsHead_right__54KlS"};